import { api } from "@/lib/api";

export const LARGE_FILE = 20 * 1024 * 1024;

// Sends a big file (e.g. a site video) in parts so long uploads survive size limits; onProgress gets 0-100.
export async function uploadInParts({ file, meta, onProgress }) {
  const { data: s } = await api.post("/documents/uploads", { ...meta, filename: file.name, size: file.size });
  let next = 0;
  try {
    while (next * s.chunk_size < file.size) {
      const part = file.slice(next * s.chunk_size, (next + 1) * s.chunk_size);
      let tries = 0;
      for (;;) {
        try {
          const r = await api.post(`/documents/uploads/${s.upload_id}/parts/${next}`, part, { headers: { "Content-Type": "application/octet-stream" } });
          next = r.data.next;
          break;
        } catch (e) {
          if (++tries >= 3 || e.response?.status < 500) throw e;
        }
      }
      onProgress(Math.min(99, Math.round((next * s.chunk_size * 100) / file.size)));
    }
    const { data } = await api.post(`/documents/uploads/${s.upload_id}/complete`);
    onProgress(100);
    return data;
  } catch (e) {
    api.delete(`/documents/uploads/${s.upload_id}`).catch(() => {});
    throw e;
  }
}
